export const exportRawPriceObject = (price: GQL.IPrice) => {
  return {
    currencyId: price.currencyId,
    priceWithout: price.priceWithout,
    recommendedPriceWithout: price.recommendedPriceWithout,
    discount: price.discount || null,
    discountPercent: price.discountPercent || null,
  };
}


// WEBPACK FOOTER //
// ./src/helpers/Prices/exportRawPriceObject.ts